 
 
    var klaviyo = klaviyo || [];
    klaviyo.init({
      account: "HFrCxx",
      platform: "shopify"
    });
    klaviyo.enable("backinstock",{ 
    trigger: {
      product_page_text: "Notify Me When Available",
      product_page_class: "btn",
      product_page_text_align: "center",
      product_page_margin: "0px",
      replace_anchor: false
    },
    modal: {
     headline: "{product_name}",
     body_content: "Sign up to receive a notification when this item comes back in stock.",
     email_field_label: "Email",
     button_label: "Notify me when available",
     subscription_success_label: "You're in! We'll let you know when it's back.",
     footer_content: '',
     additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
     drop_background_color: "#000",
     background_color: "#fff",
     text_color: "#3F3027",
     button_text_color: "#fff",
     button_background_color: "#3F3027",
     close_button_color: "#ccc",
     error_background_color: "#3F3027",
     error_text_color: "#C72E2F",
     success_background_color: "#3F3027",
     success_text_color: "#FFF"
    }
  });


 